var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackInstaComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vertical container",
    clipPath: "url(#clip0_14_7014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22283 1.17274C11.2381 1.03567 13.2343 1.63696 14.8386 2.86427C16.4428 4.09158 17.5454 5.86096 17.9404 7.84187C18.3144 9.7179 18.0295 11.6621 17.1395 13.3481L18.0766 16.8287C18.1472 17.0911 18.0717 17.3712 17.8786 17.5625C17.6856 17.7538 17.4048 17.8268 17.143 17.7537L13.7123 16.7963C12.0339 17.6952 10.0943 17.9924 8.21807 17.6319C6.23446 17.2507 4.45747 16.1604 3.21906 14.5647C1.98065 12.969 1.36552 10.977 1.4886 8.96082C1.61168 6.94468 2.46454 5.0423 3.88786 3.60907C5.31117 2.17584 7.20759 1.3098 9.22283 1.17274ZM13.9195 4.0656C12.6071 3.06158 10.9741 2.56969 9.32547 2.68182C7.67687 2.79395 6.12547 3.50243 4.96111 4.6749C3.79674 5.84738 3.09904 7.40365 2.99836 9.05299C2.89767 10.7023 3.40089 12.3319 4.41399 13.6373C5.42709 14.9427 6.88079 15.8346 8.50351 16.1465C10.1262 16.4583 11.807 16.1687 13.2317 15.3318C13.4087 15.2278 13.6204 15.2002 13.8181 15.2554L16.2709 15.94L15.5996 13.4465C15.5473 13.2524 15.5745 13.0454 15.6751 12.8714C16.5021 11.4408 16.7801 9.75812 16.457 8.13761C16.1339 6.51709 15.2319 5.06962 13.9195 4.0656Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_7014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1508,
    height: 18.1508,
    fill: "white",
    transform: "translate(0.708008 0.386963)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackInstaComment);
export default __webpack_public_path__ + "static/media/black-insta-comment.a72d6a47486370770cdd379a79d21407.svg";
export { ForwardRef as ReactComponent };